export const ROMANIAN_LOCALE = require('../languages/ro.json');
export const ENGLISH_LOCALE = require('../languages/en.json');
